import { createSelector } from 'reselect';
import { TRADEIN_ESTIMATE_COOKIE_NAME } from '@beef/shop-common';

import { getValueOfCookie, isTradeInEnabled } from 'store/common/settings/selectors';
import { getBodyData, getWidgetsData } from 'store/selectors';

import { getSharedZoneContentSettings } from '../../SharedZone/selectors';

export const getTradeInBodyData = getBodyData;
export const getTradeInWidgetData = getWidgetsData;

const getBlocksData = (state) => getBodyData(state).blocks || {};
const getCalculatorBlockData = (state) => getBlocksData(state).calculator || {};

export const getTradeInCalculatorHeadline = (state) => getCalculatorBlockData(state).headline || '';

export const getTradeInCalculatorHeadlineTagName = (state) =>
  getCalculatorBlockData(state).headlineTagName || '';

export const getTradeInCalculatorTitle = (state) => getCalculatorBlockData(state).title || '';

export const getTradeInCalculatorFootnote = (state) => getCalculatorBlockData(state).footnote || '';

export const getTradeInCalculatorErrorText = (state) =>
  getCalculatorBlockData(state).errorTradeIn || 'Произошла ошибка.';

export const getTradeInCalculatorButtonHref = (state) =>
  getCalculatorBlockData(state).buttonHref || '';

export const isTradeInNewPage = (state) => getSharedZoneContentSettings(state).page === 'new22';

// ===
const getTradeInWidgetCalculator = (state) => getTradeInWidgetData(state).TradeInCalculator || {};
const getTradeInWidgetCalculatorSettings = (state) =>
  getTradeInWidgetCalculator(state).calculatorSettings || {};

export const getTradeInCalculatorMaxPrice = (state) =>
  `${getTradeInWidgetCalculatorSettings(state).maxPrice || 0}`;

export const getTradeInCalculatorWaitStatus = (state) =>
  getTradeInWidgetCalculatorSettings(state).waitStatus || false;

export const getTradeInCalculatorErrorStatus = (state) =>
  getTradeInWidgetCalculatorSettings(state).errorStatus || false;
export const getTradeInCalculatorOptions = (state) =>
  getTradeInWidgetCalculatorSettings(state).options || [];

export const getTradeInNewCalculatorOptions = (state) =>
  getTradeInWidgetCalculatorSettings(state).options.map((option) => ({
    ...option,
    list: option.list.map((cur) => ({ slug: cur.value, label: cur.label })),
  }));

export const getTradeInActiveDeviceType = (state) =>
  (getTradeInCalculatorOptions(state).filter((option) => option.slug === 'deviceTypes')[0] || {})
    .activeOption || null;

export const getTradeInActiveBrand = (state) =>
  (getTradeInCalculatorOptions(state).filter((option) => option.slug === 'brands')[0] || {})
    .activeOption || null;

export const getTradeInActiveModel = (state) =>
  (getTradeInCalculatorOptions(state).filter((option) => option.slug === 'models')[0] || {})
    .activeOption || null;

export const getTradeInEstimate = createSelector(
  getValueOfCookie(() => TRADEIN_ESTIMATE_COOKIE_NAME),
  isTradeInEnabled,
  (estimate, isTradeIn) => {
    if (!isTradeIn) {
      return undefined;
    }

    try {
      return JSON.parse(estimate);
    } catch (e) {
      return undefined;
    }
  },
);

export const isTradeInActive = createSelector(
  getTradeInEstimate,
  (estimate) => estimate?.maxPrice && estimate.maxPrice !== '0',
);
